import React, { memo } from "react";
import classNames from "classnames/bind";
import { Button } from "@beef/ui-kit";

import { IContentActions } from 'components/Popups/CommonModal/types';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const ContentActions = memo<IContentActions>(
  ({
    onConfirm,
    onAdditionalConfirm,
    data,
    isDisabledMainBtn = false,
    isDisabledAdditionalBtn = false,
  }) => {
    const [primaryButton, secondaryButton] = data?.buttonGroup || [];

    return (
      <div className={cx("actions")}>
        <Button
          disabled={isDisabledMainBtn}
          onClick={() => onConfirm(primaryButton?.href)}
          size="m"
        >
          {primaryButton?.buttonText}
        </Button>
        {secondaryButton?.buttonText && (
          <Button
            disabled={isDisabledAdditionalBtn}
            onClick={() => onAdditionalConfirm(secondaryButton?.href)}
            size="m"
            variant="tertiary"
          >
            {secondaryButton?.buttonText}
          </Button>
        )}
      </div>
    );
  },
);

export { ContentActions };
